// assets/_animation.lenis.js
(async()=>  {
  try {
    const { default: Lenis } = await import('https://cdn.jsdelivr.net/npm/lenis@1.3.21/+esm');
    if (typeof Lenis === "undefined") return;

    const lenis = new Lenis({
      lerp: 0.1,
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: "vertical",
      gestureOrientation: "vertical",
      smoothWheel: true,
      syncTouch: false,
      infinite: false,
    });
    window.lenis = lenis;

    let fallbackRafId;
    function fallbackRaf(time) {
      lenis.raf(time);
      fallbackRafId = requestAnimationFrame(fallbackRaf);
    }

    if (typeof gsap !== "undefined" && gsap.ticker) {
      gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
      });
    } else {
      fallbackRafId = requestAnimationFrame(fallbackRaf);
      window.addEventListener('load', () => {
        if (typeof gsap !== "undefined" && gsap.ticker) {
          cancelAnimationFrame(fallbackRafId);
          gsap.ticker.add((time) => {
            lenis.raf(time * 1000);
          });
        }
      });
    }
  } catch (err) {
    console.warn("Lenis initialization skipped:", err);
  }
})();